const finmaRegex = /^[0-9]{5}$/
export default (value) => {
  const normalizedValue = String(value).trim().replace(/'/g, '')
  return finmaRegex.test(normalizedValue)
}
